const common = {
	id: 'ID',
	administration: 'Administration',
	created: 'created',
	capitalizeCreated: '@.capitalize:common.created',
	edited: 'edited',
	edit: 'Edit',
	active: 'active',
	activate: { name: 'activate', icon: 'fas fa-toggle-on' },
	deactivate: { name: 'deactivate', icon: 'fas fa-toggle-off' },
	reviewed: 'Reviewed',
	createdAt: 'Created at',
	createdBy: 'Created by',
	updated: 'updated',
	authorized: 'authorized',
	capitalizeUpdated: '@.capitalize:common.updated',
	updatedAt: 'Updated at',
	startedAt: 'Valid from',
	endedAt: 'Valid until ',
	readOn: 'Read on',
	onlyActive: 'only active',
	onlyActiveHint:
		'"Only active" shows only currently active roles. "All" additionally shows former tenants and inactive role persons.',
	description: 'Description',
	information: 'Information',
	attachFile: 'Attach files',
	properties: 'Properties',
	page: 'Page',
	toAll: 'to all',
	from: 'from',
	to: 'to',
	until: 'until',
	file: 'file | files',
	selected: 'selected',
	number: 'No.',
	send: 'Send',
	emails: 'Emails',
	general: 'General',
	appointment: 'Appointment',
	user: 'User',
	management: 'Management',
	usernameEmail: 'Username / Email',
	name: 'Name',
	color: 'Color',
	salutation: 'Salutation',
	academicTitle: 'Title',
	firstName: 'First Name',
	lastName: 'Last Name',
	password: 'Password',
	password_confirmation: 'Password Confirmation',
	selectDate: 'Select date',
	comment: 'Comment | Comments',
	Login: 'Login',
	showAll: 'Show All',
	search: 'Search',
	data: 'Data',
	no_data_available: 'No data available.',
	loaded: 'loaded',
	date: 'Date',
	type: 'Type',
	size: 'Size',
	origin: 'Origin',
	publicLabel: 'Public',
	group: 'Group',
	grouped: 'Grouped',
	list: 'List',
	toOccur: 'Due by',
	status: 'Status',
	subject: 'Subject',
	price: 'Price',
	subject_type: 'Subject type',
	characters: 'Characters',
	time: 'Time',
	loadMore: 'Load more {displayName}',
	readMore: 'read more',
	hide: 'hide',
	show: 'show',
	accept: 'Accept',
	accepted: 'Accepted',
	pending: 'Pending',
	all: 'All',
	mine: 'Mine',
	portalOwn: 'Portal only',
	openReports: 'Open',
	closedReports: 'Closed',
	dateFrom: 'Date from',
	dateTo: 'Date until',
	urgent: 'Urgent',
	finalize: 'Finalize',
	release: 'Release',
	deadline: 'Deadline',
	authorize: 'Authorize',
	confirmed: 'Confirmed',
	rejected: 'Rejected',
	reviewer: 'Reviewer',
	access: 'Access',
	yes: 'Yes',
	no: 'No',
	not: 'not',
	result: 'Result',
	storage: 'Storage',
	add_documents: 'Add Documents',
	items_per_page: 'Items per page:',
	activate: 'activate',
	recipient: 'Recipient',
	noContent: 'No content',
	reply: 'Reply',
	links: 'Links',
	remarks: 'Remarks',
	back: 'Back',
	next: 'Next',
	copy: 'Copy',
	critical: 'Critical',
	insert: 'Insert',
	actions: 'More actions',
	templates: 'Template | Templates',
	sender: 'Sender',
	placeholder: 'Placeholder',
	sendCredentials: 'Send credentials',
	fromPerspectiveOf: 'From the perspective of',
	selectFiles: 'Select files',
	changes: 'Changes',
	toBind: 'Bind',
	entry: 'Entry | Entries',
	category: 'Category',
	question: 'Question',
	scheduled: 'Scheduled',
	continue: 'Continue',
	undo: 'Undo',
	discard: 'Discard',
	team: 'Team',
	unlink: 'Unlink',
	upcoming: 'Upcoming',
	selectAll: 'Select all',
	reset: 'Reset',
	dataConfirmation: 'I confirm that the information I have entered is correct.',
	genericRetry: 'An error occurred, please try again.',
	example: {
		private: 'e.g. private',
	},
	open: {
		name: 'Open',
		icon: 'far fa-eye',
	},
	print: {
		name: 'Print',
		icon: 'far fa-print',
	},
	approve: {
		name: 'Approve',
		icon: 'fas fa-check',
	},
	confirm: {
		name: 'Confirm',
		icon: 'fa-solid fa-check',
	},
	reject: {
		name: 'Reject | Reject',
		icon: 'fa-solid fa-ban',
	},
	create: {
		name: 'Create',
		icon: 'fas fa-plus',
	},
	save: {
		name: 'Save',
		icon: 'fal fa-save',
	},
	saveAndClose: 'Save & close',
	update: {
		name: 'Update | Update',
		icon: 'fas fa-plus',
	},
	delete: {
		name: 'Delete',
		icon: 'fas fa-trash',
	},
	close: {
		name: 'Close',
		icon: 'fas fa-close',
	},
	cancel: {
		name: 'Cancel',
		icon: 'fal fa-ban',
	},
	add: {
		name: 'Add',
		icon: 'fas fa-plus',
	},
	return: {
		name: 'Back',
		icon: 'fas fa-step-backward',
	},
	login: {
		name: 'Login',
		icon: 'fal fa-sign-in',
	},
	logout: {
		name: 'Logout',
		icon: '',
	},
	settings: {
		name: 'Settings',
		icon: 'fas fa-user-cog',
	},
	reload: {
		name: 'Reload',
		icon: 'fas fa-arrows-rotate',
	},
	releaseNote: {
		name: "What's new",
		icon: 'fas fa-pen-to-square',
	},
	link: { name: 'Link | Links', icon: 'fas fa-link' },
	noLink: { name: 'No Link', icon: 'fas fa-link-horizontal-slash' },
	priority: {
		highest: 'Highest',
		high: 'High',
		medium: 'Medium',
		low: 'Low',
		lowest: 'Lowest',
		none: 'None',
	},
	privacy: 'Privacy Policy',
	imprint: 'Imprint',
	privacyPolicy: 'Privacy Policy',
	termsOfUse: 'Terms of Use',
	tabs: {
		masterData: {
			name: 'Master data',
			icon: 'fa-fw fas fa-info-square',
		},
	},
	tips: {
		passwordOnlyChangeableByTeamMember:
			'The password can only be changed by the team member themselves in the account section after initial setup',
		rolePermissionVisibleForAll:
			'If this option is enabled, persons with the <b>{0}</b> role will be available either to all or only to the selected person roles that have an active role in the same building or unit. This setting applies regardless of the access rules set.',
		rolePermissionGrantsAccessToAllPersonsOfUnitOrBuilding:
			'The <b>{0}</b> role, when this option is enabled, will have access to the persons located in the <b>{1}</b> with the selected active person roles',
		rolePermissionGrantsAccessToAllUnitsOfBuilding:
			'If this option is enabled and the person role is linked to the building and not to a specific unit, all units within the building will be accessible!',
		userNameCannotBeChanged:
			'Username / email cannot be changed after the initial setup',
		unitAddressLinkIsRequired:
			'If this option is enabled, only documents assigned to the unit and the corresponding address will be displayed. This setting applies exclusively to documents linked to the unit.',
		notesCreateBuildingLinkInfo:
			'The assigned buildings and person roles also apply to notifications. If no building is selected but only person roles, notifications will be sent for all buildings. If the "urgent" option is selected, user preferences are ignored and the notification is still sent.',
		reviewDocumentsReminderInfo:
			'Here you can set whether and when a reminder email should be sent for the document review.',
	},
	viewAll: 'View all',
}

export default common
